import fetchJSON from '@api/api_helper';
import { PortalCard, PortalCardResponse, PortalCardsResponse } from '@api/v4/private/PortalCardTypes';
import { ApiDataResponse } from '@api/v4/ApiResponseTypes';
import { Asset } from '@api/v4/assets/assetTypes';

const portalCardsForPortal = (portalId: string): string => `/api/v4/private/portals/${portalId}/portal_cards`;
const portalCardUrl = (portalCardId: string): string => `/api/v4/private/portal_cards/${portalCardId}`;

// NOTE: implement updateFetchControllers
export const getPortalCards = (options): Promise<PortalCardsResponse> => (
  fetchJSON(portalCardsForPortal(options.portalId), options, (): void => { /* no op */ })
);

// NOTE: implement updateFetchControllers
export const getPortalCard = (options): Promise<PortalCardResponse> => (
  fetchJSON(portalCardUrl(options.portalCardId), options, (): void => { /* no op */ })
);

// starting with assets, this may need to evolve
// NOTE: implement updateFetchControllers
export const getPortalCardData = (options): Promise<ApiDataResponse<Asset>> => (
  fetchJSON(`${portalCardUrl(options.portalCardId)}/data`, options, (): void => { /* no op */ })
);

export const createPortalCard = (
  portalId: string,
  {
    name,
    position,
    type,
    description,
    displayWidth,
    iconUrl,
    imageUrl,
    linkUrl,
    subType,
    widgetResource
  }: PortalCard
): Promise<PortalCardResponse> => {
  const appendedOptions = {
    body: {
      data: {
        attributes: {
          name: name.trim(),
          position,
          type,
          description: description?.trim(),
          display_width: displayWidth,
          icon_url: iconUrl,
          image_url: imageUrl,
          link_url: linkUrl,
          sub_type: subType
        }
      },
      resource_type: widgetResource ? widgetResource.type : null,
      resource_key: widgetResource ? widgetResource.key : null,
    },
    method: 'POST'
  };

  // NOTE: implement updateFetchControllers
  return fetchJSON(portalCardsForPortal(portalId), appendedOptions, () => { /* no op */ })
    .then((response): PortalCardResponse => response);
};

export const updatePortalCard = (
  portalCardId: string,
  {
    name,
    position,
    type,
    description,
    displayWidth,
    iconUrl,
    imageUrl,
    linkUrl,
    subType,
    widgetResource
  }: PortalCard
): Promise<PortalCardResponse> => {
  const appendedOptions = {
    body: {
      data: {
        attributes: {
          name: name.trim(),
          position,
          type,
          description: description?.trim(),
          display_width: displayWidth,
          icon_url: iconUrl,
          image_url: imageUrl,
          link_url: linkUrl,
          sub_type: subType,
        }
      },
      resource_type: widgetResource ? widgetResource.type : null,
      resource_key: widgetResource ? widgetResource.key : null,
    },
    method: 'PUT'
  };

  // NOTE: implement updateFetchControllers
  return fetchJSON(portalCardUrl(portalCardId), appendedOptions, () => { /* no op */ })
    .then((response): PortalCardResponse => response);
};

export const deletePortalCard = (portalCardId: string): Promise<{}> => {
  const appendedOptions = {
    method: 'DELETE'
  };

  // NOTE: implement updateFetchControllers
  return fetchJSON(portalCardUrl(portalCardId), appendedOptions, () => { /* no op */ })
    .then((response) => response);
};
